import React from 'react';
import Spinner from 'react-bootstrap/Spinner';
import { ScrollableQueryResult } from 'hooks/use-scrollable-query';
import { Checkbox, SpinnerOrAlert } from '@spins/react-ui-library';
import InfiniteScroll from 'react-infinite-scroll-component';
import styles from './styles.module.scss';

interface OptionsScrollableListProps {
  currentItems: Array<any>;
  disabled?: boolean;
  totalItems: number;
  queryResult: ScrollableQueryResult<any>;
  scrollableTarget: string;
  selectedItemsIds: Array<string>;
  setSelectedItem: any;
  allSelected: boolean;
}

const OptionsScrollableList: React.FC<OptionsScrollableListProps> = ({
  currentItems,
  totalItems,
  queryResult,
  scrollableTarget,
  selectedItemsIds,
  setSelectedItem,
  allSelected,
  disabled = false,
}) => {
  return (
    <SpinnerOrAlert loading={queryResult.loading} error={queryResult.error !== undefined}>
      <InfiniteScroll
        className={styles.optionsScrollableList}
        dataLength={currentItems.length}
        next={queryResult.pagination.fetchMore}
        hasMore={currentItems.length < totalItems}
        loader={
          <div className={styles.spinnerContainer}>
            <Spinner animation="border" size="sm" />
          </div>
        }
        scrollableTarget={scrollableTarget}
        scrollThreshold={0.9}
      >
        {currentItems.map((item, index) => (
          <div
            data-testid="select-option"
            key={`${item.id}-${index}`}
            className={styles.itemContainer}
          >
            <Checkbox
              className={styles['checkbox']}
              checked={
                allSelected ||
                selectedItemsIds.some((id) => {
                  return item.id === id;
                })
              }
              label={item.label}
              id={item.id}
              onChange={() => {
                setSelectedItem(item);
              }}
            />
          </div>
        ))}
      </InfiniteScroll>
    </SpinnerOrAlert>
  );
};

export default OptionsScrollableList;
